<template>
  <lf-content-loader :is-loading="runScorecardIds.includes(model.id)">
    <scorecard-risk-tier-pill
      v-if="!!model.results?.length"
      font-size="text-xxs"
      :risk-tier="riskTierContent"
      readonly
    />
  </lf-content-loader>
</template>

<script setup lang="ts">
import { computed } from "vue";

import {
  getGroupResults,
  getResults,
  modelIsScorecardGroup,
} from "@/helpers/scorecards";
import { useScorecardsBase } from "@/hooks/scorecards";

import ScorecardRiskTierPill from "@/components/scorecards/ScorecardRiskTierPill.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard, IScorecardGroup } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();

const props = defineProps<{
  model: IScorecard | IScorecardGroup;
}>();

const riskTierContent = computed(() => {
  if (modelIsScorecardGroup(props.model)) {
    return getGroupResults(props.model)[0]?.score_card_group_risk_tier;
  }

  return getResults(props.model as IScorecard)[0]?.score_card_risk_tier;
});
</script>
